import api from '@/api'
export default {
  namespaced: true,
  state: {
    projectIdArr: [],
    loadingId: false
  },
  getters: {},
  actions: {
    async fetchProjectId(context) {
      if (context.state.projectIdArr && context.state.projectIdArr.length > 0)
        return
      if (context.state.loadingId) return
      context.commit('updateLoadingId', true)
      let res = await api.post({
        url: 'merApi/houseRental/rules/mgmt/queryDuhdMrchnt',
        data: {
          custId: context.rootState.user.userInfo.custId
        }
      })
      console.log(res, '---fetchProjectId')
      context.commit('updateLoadingId', false)
      if (res) {
        let dataList = res.dataList || []
        context.commit('updateProjectId', dataList)
      }
    }
  },
  mutations: {
    updateLoadingId(state, data) {
      state.loadingId = data
    },
    updateProjectId(state, projectIds) {
      state.projectIdArr = projectIds
    }
  }
}
